import {GROUP_TYPE, GROUP_SECTION_WIDTH, drawBorderLines, drawBackground} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import Util from '../../../../forecast-app/shared/util/util';
import {drawExpandAllImageIcon} from '../../canvas-timeline/canvas_timeline_icon_util';

class CompanyUtilizationGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PEOPLE_SCHEDULING_COMPANY_UTILIZATION, data);
	}

	draw(canvasContext, x, y, collapsableSectionHeight) {
		const width = GROUP_SECTION_WIDTH();
		const {height, expanded, preventExpansion} = this;
		super.draw(x, y, width, height, this, collapsableSectionHeight);
		drawBackground(canvasContext, x, y, width, height, true);
		canvasContext.fillStyle = '#535353';
		canvasContext.font = '700 12px ' + Util.getFontFamily();
		const textMarginX = preventExpansion ? 15 : 40;
		canvasContext.fillText(this.data.formatMessage({id: 'scheduling.total_resource_utilization'}), x + textMarginX, y + 28);
		drawBorderLines(canvasContext, 0, y, width, height, true);
		if (!preventExpansion) {
			drawExpandAllImageIcon(canvasContext, 0, y, width, height, {expanded, align: 'left'});
		}
	}
}

export default CompanyUtilizationGroup;
